module.exports = __webpack_public_path__ + "img/banner.b6fd3bb4.png";